import { useDispatch } from "react-redux";
import "./DashboardLayout.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { setCurrentUser } from "../../redux/slices/userSlice";
import { showToast } from "../../components/Toaster/Toaster";
import { axiosApiCall } from "../../utils/axiosHelper";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { authSession } from "../../utils/authService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";

const DashboardLayout: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(true);
  const [isMeetingRoute] = useState(location.pathname.startsWith("/meeting"));

  const getCurrentUser = async () => {
    const accessToken = await authSession();
    if (!accessToken && !isMeetingRoute) {
      navigate("/login");
      return;
    }

    try {
      // Only try to fetch user if we have a accessToken
      if (accessToken) {
        const userResponse = await axiosApiCall("/auth/me", "GET");
        if (userResponse?.statusCode !== 200) {
          throw new Error(userResponse?.body.message || "Failed to fetch user");
        }

        const response = userResponse?.body.user;
        dispatch(
          setCurrentUser({
            userId: response.u_id,
            email: response.u_email,
            userName: response.u_last_name ? `${response.u_first_name} ${response.u_last_name}` : `${response.u_first_name}`,
            firstName: response.u_first_name,
            lastName: response.u_last_name,
          })
        );
      }
    } catch (error: any) {
      showToast(error.message || "Error fetching user data", "error");
      if (!isMeetingRoute) {
        localStorage.clear();
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  if (loading && !isMeetingRoute) {
    return <LoadingSpinner />;
  }

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default DashboardLayout;
